import { useUpdateName } from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import { useAccentColor } from "Login/TwoFA/stateHooks";

import FnrTypeNSave from "UI/FnrTypeNSave";

const FullName = () => {
  const { fullName, setFullName, stoutInputs } = useTwoFAContext();
  const [{ isLoading }, update] = useUpdateName();
  const accentColor = useAccentColor();

  return (
    <FnrTypeNSave
      data-cy="TwoFA_FullName_Input"
      value={fullName}
      setValue={setFullName}
      placeholder="Full Name"
      size="lg"
      onSubmit={update}
      icon="fa-user fas"
      buttonColor={accentColor}
      iconColor={accentColor}
      isLoading={isLoading}
      focusColor={accentColor}
      stout={stoutInputs}
      style={{ borderRadius: "9999px" }}
    />
  );
};

export default FullName;
